
function Steps() {

    const handleRegisterClick = () => {
        window.open(process.env.REACT_APP_REGISTER_URL, '_blank');
    };

    return (
        <section id="how-it-works" className="py-20 px-4 bg-primary text-white">
            <div className="max-w-7xl mx-auto text-center">
                <h3 className="text-3xl md:text-4xl font-extrabold mb-16">Démarrer en 3 étapes simples</h3>
                <div className="grid md:grid-cols-3 gap-12">
                    {[
                        { step: "01", title: "Créez votre cabinet", desc: "Inscrivez-vous en 2 minutes et paramétrez vos traitements habituels." },
                        { step: "02", title: "Ajoutez vos patients", desc: "Importez votre liste actuelle ou ajoutez-les au fur et à mesure." },
                        { step: "03", title: "Gérez votre quotidien", desc: "Prenez des rendez-vous, saisissez les actes et suivez vos paiements." }
                    ].map((item, i) => (
                        <div key={i} className="relative space-y-4">
                            <div className="text-6xl font-black text-white/10 absolute -top-8 left-1/2 -translate-x-1/2">{item.step}</div>
                            <h4 className="text-2xl font-bold relative z-10">{item.title}</h4>
                            <p className="text-blue-100 leading-relaxed max-w-xs mx-auto">{item.desc}</p>
                        </div>
                    ))}
                </div>
                <button onClick={handleRegisterClick} className="mt-16 bg-white text-primary px-8 py-3 rounded-2xl text-lg font-bold hover:bg-blue-50 transition-all shadow-xl">
                    Créer mon cabinet
                </button>
            </div>
        </section>
    );
}

export default Steps;